import { ColorBot } from '@givebacks/color-bot';
import { useQuery } from '@tanstack/react-query';

const useColorBotQuery = ({
  imageSrc,
  enabled = true,
}: {
  imageSrc?: string;
  enabled?: boolean;
}) => {
  const _enabled = !!imageSrc;

  return useQuery({
    queryKey: ['color-bot', imageSrc],
    queryFn: async () => {
      if (!imageSrc) return null;

      const newImageProcessor = new ColorBot();
      await newImageProcessor.loadImage({ imageSrc });
      newImageProcessor.processImage();
      newImageProcessor.calculatePalette();
      newImageProcessor.generateColorShades();
      return newImageProcessor.getSnapshot();
    },
    enabled: _enabled && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export { useColorBotQuery };
